"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ShapeElement_1 = require("./ShapeElement");
var ShapeElementFactory_1 = require("./ShapeElementFactory");
var Group = (function (_super) {
    tslib_1.__extends(Group, _super);
    function Group(rawData, version) {
        var _this = _super.call(this, rawData, version) || this;
        _this.shapes = _this._rawData.it.map(function (shapeElementRawData) {
            return ShapeElementFactory_1.constructShapeElementFromRawData(shapeElementRawData, version);
        });
        return _this;
    }
    Object.defineProperty(Group.prototype, "numberOfProperties", {
        get: function () {
            return this._rawData.np;
        },
        set: function (numberOfProperties) {
            this._rawData.np = numberOfProperties;
        },
        enumerable: true,
        configurable: true
    });
    return Group;
}(ShapeElement_1.ShapeElement));
exports.Group = Group;
//# sourceMappingURL=Group.js.map